import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MngAdminComponent } from './mng-admin.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { MngAdminRoutingModule } from './mng-admin-routing.module';
import { ZoneModule } from '../zone/zone.module';
import { UsersComponent } from './users/users.component';
import { SettingsComponent } from './settings/settings.component';
import { ProfileComponent } from './profile/profile.component';
//import { SettingsModule } from './../settings/settings.module';


@NgModule({
  declarations: [MngAdminComponent,
    UsersComponent,
    SettingsComponent,
    ProfileComponent],
  imports: [
    CommonModule,
    SharedModule,
    MngAdminRoutingModule,
    ZoneModule//,
   // SettingsModule
  ]
})
export class MngAdminModule { }
